import { action } from "typesafe-actions";
import { HallFloorActionTypes } from "./types";
import {
  CreateHallFloorPayload,
  DeleteHallFloorPayload,
  GetHallFloorPayload,
  HallFloor,
  UpdateHallFloorPayload,
} from "../../interfaces/HallFloor";
import { message } from "antd";

export const getHallFloors = (payload: string | number) => {
  return action(HallFloorActionTypes.FETCH_FLOORS_REQUEST, payload);
};

export const getHallFloorsSuccess = (halls: HallFloor[]) => {
  return action(HallFloorActionTypes.FETCH_FLOORS_SUCCESS, halls);
};

export const getHallFloorsFailure = (error: any) => {
  return action(HallFloorActionTypes.FETCH_FLOORS_ERROR, error);
};

export const getHallFloor = (payload: GetHallFloorPayload) => {
  return action(HallFloorActionTypes.FETCH_FLOOR_REQUEST, payload);
};

export const getHallFloorSuccess = (hall: HallFloor) => {
  return action(HallFloorActionTypes.FETCH_FLOOR_SUCCESS, hall);
};

export const getHallFloorFailure = (error: any) => {
  message.error(error);
  return action(HallFloorActionTypes.FETCH_FLOOR_ERROR, error);
};

export const createHallFloor = (payload: CreateHallFloorPayload) => {
  return action(HallFloorActionTypes.CREATE_FLOOR_REQUEST, payload);
};

export const createHallFloorSuccess = (hall: HallFloor) => {
  return action(HallFloorActionTypes.CREATE_FLOOR_SUCCESS, hall);
};

export const createHallFloorFailure = (error: any) => {
  return action(HallFloorActionTypes.CREATE_FLOOR_ERROR, error);
};

export const updateHallFloor = (payload: UpdateHallFloorPayload) => {
  return action(HallFloorActionTypes.UPDATE_FLOOR_REQUEST, payload);
};

export const updateHallFloorSuccess = (hall: HallFloor) => {
  return action(HallFloorActionTypes.UPDATE_FLOOR_SUCCESS, hall);
};

export const updateHallFloorFailure = (error: any) => {
  return action(HallFloorActionTypes.UPDATE_FLOOR_ERROR, error);
};

export const deleteHallFloor = (payload: DeleteHallFloorPayload) => {
  return action(HallFloorActionTypes.DELETE_FLOOR_REQUEST, payload);
};

export const deleteHallFloorSuccess = (hall: CreateHallFloorPayload) => {
  return action(HallFloorActionTypes.DELETE_FLOOR_SUCCESS, hall);
};

export const deleteHallFloorFailure = (error: any) => {
  return action(HallFloorActionTypes.DELETE_FLOOR_ERROR, error);
};

export const clearFloorState = () => {
  return action(HallFloorActionTypes.CLEAR_FLOOR_STATE);
};
